import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { firestore } from '../config/firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import './ContatoDetails.css';


function ContatoDetails() {
  const { id } = useParams();
  const [contato, setcontato] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchcontato = async () => {
      try {
        const docRef = doc(firestore, 'contatos', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setcontato({ id: docSnap.id, ...docSnap.data() });
          setFormData({ ...docSnap.data() });
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Erro ao buscar contato:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchcontato();
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(firestore, 'contatos', id);
      
      const updatedData = {
        ...formData,
        dataUltimaAtualizacao: new Date().toISOString(), 
      };

      await updateDoc(docRef, updatedData);
      setcontato({ ...contato, ...updatedData });
      setIsEditing(false);
    } catch (error) {
      console.error('Erro ao atualizar contato:', error);
    }
  };

  const calculateCompletionPercentage = () => {
    const totalFields = Object.keys(formData).length;
    const filledFields = Object.values(formData).filter(value => value && value.trim() !== '').length;
    return Math.round((filledFields / totalFields) * 100);
  };

  if (loading) return <p>Carregando...</p>;

  const completionPercentage = calculateCompletionPercentage();

  return (
    <div className="contato-details">
      {contato ? (
        <>
          {isEditing ? (
            <form onSubmit={handleFormSubmit}>
              <h1>Editar Contato</h1>
              <label>
                Nome:
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Data de Nascimento:
                <input
                  type="date"
                  name="dataNascimento"
                  value={formData.dataNascimento}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Gênero:
                <input
                  type="text"
                  name="genero"
                  value={formData.genero}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Telefone:
                <input
                  type="text"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Curso:
                <input
                  type="text"
                  name="curso"
                  value={formData.curso}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Turma:
                <input
                  type="text"
                  name="turma"
                  value={formData.turma}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Interesses:
                <input
                  type="text"
                  name="interesses"
                  value={formData.interesses}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Objetivos:
                <input
                  type="text"
                  name="objetivos"
                  value={formData.objetivos}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                LinkedIn:
                <input
                  type="url"
                  name="linkedin"
                  value={formData.linkedin}
                  onChange={handleInputChange}
                />
              </label>
              <button type="submit">Salvar</button>
              <button type="button" onClick={handleEditToggle}>Cancelar</button>
            </form>
          ) : (
            <>
              <h1>{contato.nome}</h1>
              <div className="completion-bar">
                <div className="completion-bar-filled" style={{ width: `${completionPercentage}%` }}>
                  {completionPercentage}%
                </div>
              </div>
              <p><strong>Data de Nascimento:</strong> {contato.dataNascimento}</p>
              <p><strong>Gênero:</strong> {contato.genero}</p>
              <p><strong>Email:</strong> {contato.email}</p>
              <p><strong>Telefone:</strong> {contato.telefone}</p>
              <p><strong>Endereço:</strong> {contato.endereco}</p>
              <p><strong>Instituição:</strong> {contato.instituicao}</p>
              <p><strong>Cargo:</strong> {contato.cargo}</p>
              <p><strong>Curso:</strong> {contato.curso}</p>
              <p><strong>Turma:</strong> {contato.turma}</p>
              <p><strong>Interesses:</strong> {contato.interesses}</p>
              <p><strong>Objetivos:</strong> {contato.objetivos}</p>
              <p><strong>LinkedIn:</strong> <a href={contato.linkedin} target="_blank" rel="noopener noreferrer">{contato.linkedin}</a></p>
              <button onClick={handleEditToggle}>Editar</button>
              </>
              
          )}
        </>
      ) : (
        <p>contato não encontrado.</p>
      )}
    </div>
  );
}

export default ContatoDetails;
